import AppStatisticModal from './AppStatisticModal';

export default AppStatisticModal;